import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar({ currentDatabase, databases, onDatabaseSwitch, multiDatabase = true }) {
  const navigate = useNavigate();

  const databaseOptions = Array.isArray(databases) ? databases : [];

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          📦 StowIt
        </Link>
        
        <div className="navbar-menu">
          <ul className="nav-items">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/locations">Storage</Link></li>
            <li><Link to="/items">Items</Link></li>
            <li><Link to="/scan">Scan QR</Link></li>
            {multiDatabase && <li><Link to="/databases">Databases</Link></li>}
          </ul>
        </div>

        <div className="navbar-database" style={multiDatabase ? undefined : { display: 'none' }}>
          <select 
            value={currentDatabase} 
            onChange={(e) => onDatabaseSwitch(e.target.value)}
            className="database-selector"
          >
            {databaseOptions.length > 0 ? (
              databaseOptions.map(db => (
                <option key={db.name} value={db.name}>{db.name}</option>
              ))
            ) : (
              <option disabled>No databases</option>
            )}
          </select>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
